<template>
	<div>
		<headTip></headTip>
		<router-view></router-view>
		<footerTip></footerTip>
	</div>
</template>

<script>
	import headTip from '../../components/headTip.vue'
	import footerTip from '../../components/footerTip.vue'

	export default {
		components: {
			headTip,
			footerTip
		},
	}
</script>

<style scoped>
	
</style>
